export default __webpack_public_path__ + "static/media/robot-orange.ba59d079.svg";